import React from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';

export default function SitePageLayout({ children }) {
  return (
    <div className="min-h-screen bg-background font-body text-foreground">
      <Header />
      <main className="min-h-screen pt-14 sm:pt-16 2xl:pt-20 3xl:pt-24">
        {children}
      </main>
      <Footer />
    </div>
  );
}
